import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { Icon } from '@ibk/shared-ui';
import styles from './ProtocolSearch.module.css';
export const ProtocolSearch = ({ value, onChange, onClear, isLoading = false, disabled = false, placeholder, 'data-testid': testId, }) => {
    const { t } = useTranslation();
    const [isFocused, setIsFocused] = useState(false);
    const handleInputChange = useCallback((event) => {
        onChange(event.target.value);
    }, [onChange]);
    const handleClear = useCallback(() => {
        onChange('');
        onClear();
    }, [onChange, onClear]);
    const handleFocus = useCallback(() => {
        setIsFocused(true);
    }, []);
    const handleBlur = useCallback(() => {
        setIsFocused(false);
    }, []);
    const displayValue = value || '';
    const placeholderText = placeholder || t('benefits.recharge-history.search.placeholder');
    return (_jsx("div", { className: `${styles.container} ${disabled ? styles.disabled : ''}`, "data-testid": testId, children: _jsxs("div", { className: `${styles.inputWrapper} ${isFocused ? styles.focused : ''} ${value ? styles.hasValue : ''}`, children: [_jsx(Icon, { name: 'search', className: styles.searchIcon }), _jsx("input", { type: 'text', value: displayValue, onChange: handleInputChange, onFocus: handleFocus, onBlur: handleBlur, placeholder: placeholderText, disabled: disabled || isLoading, className: styles.input, "data-testid": `${testId}-input`, autoComplete: 'off' }), value && !isLoading && (_jsx("button", { type: 'button', onClick: handleClear, className: styles.clearButton, disabled: disabled, "data-testid": `${testId}-clear`, "aria-label": t('benefits.recharge-history.search.clear'), children: _jsx(Icon, { name: 'close', className: styles.clearIcon }) })), isLoading && (_jsx("div", { className: styles.loadingIcon, "data-testid": `${testId}-loading`, children: _jsx(Icon, { name: 'loading', className: styles.spinner }) }))] }) }));
};
